<div class="separator">{{ text }}</div>
